import { Box, Grid, MenuItem, Select } from "@mui/material";
import * as React from "react";
import { CheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/CheckboxDropdown";
import { TreeCheckboxDropdown } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown";
import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { IListFilterItem } from "../../../models/common/listFilterItem";
import { DatePicker } from "../../framework/DateTime/DatePicker";
import { FilterButtons } from "../../framework/Filters/FilterButtons";
import { FilterSearchField } from "../../framework/Filters/FilterSearchField";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";

export interface IWhistleBlowFilterProp {
    classes?: string;
    filter: IListFilterItem;
    units: IIdTitleNode[];
    categories: IIdTitle[];
    handlers: IIdTitle[];
    stateFilters: IIdTitle[];
    severityFilters: IIdTitle[];
    resolutionFilters: IIdTitle[];
    sourceFilters: IIdTitle[];
    anonymityFilters: IIdTitle[];
    dynamicTimeFilters: IIdTitle[];
    size: "sm" | "lg";
    selectedStartDate: number;
    selectedEndDate: number;
    selectedUnitIds: string[];
    selectedCategoryIds: string[];
    selectedHandlerUserCodes: string[];
    selectedStateFilterId: string;
    selectedSeverityFilterId: string;
    selectedResolutionFilterId: string;
    selectedSourceFilterId: string;
    selectedAnonymityFilterId: string;
    selectedDynamicTimeFilterId: string;
    canRemoveSharedFilters: boolean;
    stateIsReadOnly?: boolean;
    onSaveFilter: (saveAs: boolean, onGetGeneralFilter: () => any) => void;
    onRemoveFilter: (filterId: string) => void;
    onOk: (closeDialog: boolean, startDate: number, endDate: number, selectedStateFilterId: string, selectedSeverityFilterId: string, selectedResolutionFilterId: string,
        selectedSourceFilterId: string, selectedAnonymityFilterId: string, selectedDynamicTimeFilterId: string, selectedCategoryIds: string[], selectedHandlerUserCodes: string[],
        selectedUnitIds: string[]) => any;
    onCancel: () => void;
}

export interface IWhistleBlowFilterState {
    startDateStr: string;
    endDateStr: string;
    selectedStateFilterId: string;
    selectedSeverityFilterId: string;
    selectedResolutionFilterId: string;
    selectedSourceFilterId: string;
    selectedAnonymityFilterId: string;
    selectedDynamicTimeFilterId: string;
    selectedCategoryIds: string[];
    selectedHandlerUserCodes: string[];
    selectedUnitIds: string[];
    startEndDateDisabled: boolean;
}

export class WhistleBlowFilter extends React.Component<IWhistleBlowFilterProp, IWhistleBlowFilterState> {
    private orgStateHash: string = "";

    getStateFromProps = (props: IWhistleBlowFilterProp): IWhistleBlowFilterState => {
        return {
            startDateStr: props.selectedStartDate ? Base.timeToDateStr(props.selectedStartDate) : "",
            endDateStr: props.selectedEndDate ? Base.timeToDateStr(props.selectedEndDate) : "",
            selectedStateFilterId: props.selectedStateFilterId,
            selectedSeverityFilterId: props.selectedSeverityFilterId,
            selectedResolutionFilterId: props.selectedResolutionFilterId,
            selectedSourceFilterId: props.selectedSourceFilterId,
            selectedAnonymityFilterId: props.selectedAnonymityFilterId,
            selectedDynamicTimeFilterId: props.selectedDynamicTimeFilterId,
            selectedCategoryIds: props.selectedCategoryIds.slice(0),
            selectedHandlerUserCodes: props.selectedHandlerUserCodes.slice(0),
            selectedUnitIds: props.selectedUnitIds.slice(0),
            startEndDateDisabled: props.selectedDynamicTimeFilterId !== props.dynamicTimeFilters[0].id
        };
    };

    constructor(props: IWhistleBlowFilterProp) {
        super(props);
        this.state = this.getStateFromProps(props);
        this.orgStateHash = this.getSaveDataFromState(props, this.state).hash;
    }

    componentDidUpdate(prevProps: IWhistleBlowFilterProp, prevState: IWhistleBlowFilterState): void {
        const props = this.props;
        if (!prevProps || prevProps.filter?.getHash() === props.filter?.getHash()) return;
        const state = this.getStateFromProps(props);
        this.setState(state);
        this.orgStateHash = this.getSaveDataFromState(props, state).hash;
    }

    handleChange = (event) => {
        const target = event.target;
        const value: string = target.value;
        const name: string = target.name;
        if (name === "selectedStateFilterId") {
            this.setState({ selectedStateFilterId: value });
        } else if (name === "selectedSeverityFilterId") {
            this.setState({ selectedSeverityFilterId: value });
        } else if (name === "selectedResolutionFilterId") {
            this.setState({ selectedResolutionFilterId: value });
        } else if (name === "selectedSourceFilterId") {
            this.setState({ selectedSourceFilterId: value });
        } else if (name === "selectedAnonymityFilterId") {
            this.setState({ selectedAnonymityFilterId: value });
        } else if (name === "selectedDynamicTimeFilterId") {
            if (value.toInteger() > 0) {
                this.setState({ selectedDynamicTimeFilterId: value, startDateStr: "", endDateStr: "", startEndDateDisabled: true });
            } else {
                this.setState({ selectedDynamicTimeFilterId: value, startEndDateDisabled: false });
            }
        }
    };

    handleChangeUnitIds = (selectedUnitIds: string[]) => {
        this.setState({
            selectedUnitIds
        });
    };

    handleChangeCategoryIds = (selectedCategoryIds: string[]) => {
        this.setState({
            selectedCategoryIds
        });
    };

    handleChangeHandlerUserCodes = (selectedHandlerUserCodes: string[]) => {
        this.setState({
            selectedHandlerUserCodes
        });
    };

    handleStartDateChange = (value: string) => {
        this.setState({ startDateStr: value });
    };

    handleEndDateChange = (value: string) => {
        this.setState({ endDateStr: value });
    };

    getSaveDataFromState = (_props: IWhistleBlowFilterProp, state: IWhistleBlowFilterState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("startDate", state.startDateStr);
        result.append("endDate", state.endDateStr);
        result.append("selectedStateFilterId", state.selectedStateFilterId ? state.selectedStateFilterId : null);
        result.append("selectedSeverityFilterId", state.selectedSeverityFilterId ? state.selectedSeverityFilterId : null);
        result.append("selectedResolutionFilterId", state.selectedResolutionFilterId ? state.selectedResolutionFilterId : null);
        result.append("selectedSourceFilterId", state.selectedSourceFilterId ? state.selectedSourceFilterId : null);
        result.append("selectedAnonymityFilterId", state.selectedAnonymityFilterId ? state.selectedAnonymityFilterId : null);
        result.append("selectedDynamicTimeFilterId", state.selectedDynamicTimeFilterId ? state.selectedDynamicTimeFilterId : null);
        result.append("selectedCategoryIds", state.selectedCategoryIds);
        result.append("selectedHandlerUserCodes", state.selectedHandlerUserCodes);
        result.append("selectedUnitIds", state.selectedUnitIds);
        return result;
    };

    static filterIsSet = (units: IIdTitleNode[], categories: IIdTitle[], handlers: IIdTitle[], stateFilters: IIdTitle[], severityFilters: IIdTitle[], resolutionFilters: IIdTitle[], sourceFilters: IIdTitle[],
        anonymityFilters: IIdTitle[], dynamicTimeFilters: IIdTitle[],
        startDate: number, endDate: number, selectedUnitIds: string[], selectedCategoryIds: string[], selectedHandlerUserCodes: string[], selectedStateFilterId: string, selectedSeverityFilterId: string,
        selectedResolutionFilterId: string, selectedSourceFilterId: string, selectedAnonymityFilterId: string, selectedDynamicTimeFilterId: string,
        defaultStateFilterIndex: number = 0): boolean => {
        return !!startDate || !!endDate ||
            !(selectedStateFilterId === stateFilters[defaultStateFilterIndex].id &&
            selectedSeverityFilterId === severityFilters[0].id &&
            selectedResolutionFilterId === resolutionFilters[0].id &&
            selectedSourceFilterId === sourceFilters[0].id &&
            selectedAnonymityFilterId === anonymityFilters[0].id &&
            selectedDynamicTimeFilterId === dynamicTimeFilters[0].id &&
            Base.equalStrArrays(selectedCategoryIds, [categories[0].id]) &&
            Base.equalStrArrays(selectedHandlerUserCodes, [handlers[0].id]) &&
            Base.equalStrArrays(selectedUnitIds, [units[0].id]));
    };

    handleSaveFilter = async (saveAs: boolean) => {
        const props = this.props;
        const state = this.state;
        const startDate = state.startDateStr ? state.startDateStr.toDate().getTime() : null;
        const endDate = state.endDateStr ? state.endDateStr.toDate().getTime() : null;
        if (!saveAs) {
            props.onOk(false, startDate, endDate,
                state.selectedStateFilterId, state.selectedSeverityFilterId, state.selectedResolutionFilterId,
                state.selectedSourceFilterId, state.selectedAnonymityFilterId, state.selectedDynamicTimeFilterId,
                state.selectedCategoryIds, state.selectedHandlerUserCodes, state.selectedUnitIds);
            await this.props.onSaveFilter(false, null);
        } else {
            await this.props.onSaveFilter(true, () => {
                return props.onOk(false, startDate, endDate,
                    state.selectedStateFilterId, state.selectedSeverityFilterId, state.selectedResolutionFilterId,
                    state.selectedSourceFilterId, state.selectedAnonymityFilterId, state.selectedDynamicTimeFilterId,
                    state.selectedCategoryIds, state.selectedHandlerUserCodes, state.selectedUnitIds);
            });
        }
    };

    handleClear = () => {
        const props = this.props;
        this.setState({
            startDateStr: "",
            endDateStr: "",
            selectedStateFilterId: props.onSaveFilter && props.onRemoveFilter ? props.stateFilters[0].id : this.state.selectedStateFilterId,
            selectedSeverityFilterId: props.severityFilters[0].id,
            selectedResolutionFilterId: props.resolutionFilters[0].id,
            selectedSourceFilterId: props.sourceFilters[0].id,
            selectedAnonymityFilterId: props.anonymityFilters[0].id,
            selectedDynamicTimeFilterId: props.dynamicTimeFilters[0].id,
            selectedCategoryIds: [props.categories[0].id],
            selectedHandlerUserCodes: [props.handlers[0].id],
            selectedUnitIds: [props.units[0].id]
        });
    };

    handleSave = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(true, state.startDateStr ? state.startDateStr.toDate().getTime() : null,
            state.endDateStr ? state.endDateStr.toDate().getTime() : null,
            state.selectedStateFilterId, state.selectedSeverityFilterId, state.selectedResolutionFilterId,
            state.selectedSourceFilterId, state.selectedAnonymityFilterId, state.selectedDynamicTimeFilterId,
            state.selectedCategoryIds, state.selectedHandlerUserCodes, state.selectedUnitIds);
    };

    handleCancel = async (checkChanges: boolean) => {
        AppUtils.cancelEditDialog(checkChanges, this.getSaveDataFromState(this.props, this.state).hash, this.orgStateHash, this.handleSave, this.props.onCancel, Translations.YouHaveUnapprovedChangesDoYouWantApproveChanges);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Box display="flex" flexDirection="column" justifyContent="space-between" flexGrow={2} width="100%">
                <Box display="flex" flexDirection="column" flexGrow={2}>
                    {!!props.onSaveFilter && !!props.onRemoveFilter &&
                        <FilterSearchField
                            filter={props.filter}
                            canRemoveSharedFilters={props.canRemoveSharedFilters}
                            onSaveFilter={props.onSaveFilter ? this.handleSaveFilter : null}
                            onRemoveFilter={props.onRemoveFilter}
                        />
                    }
                    <FormField title={Translations.WhistleBlowDateAndTime}>
                        <GridRow>
                            <Grid item sm={props.size === "sm" ? 12 : 4}>
                                <Select name="selectedDynamicTimeFilterId" title={Translations.WhistleBlowDateAndTime} value={state.selectedDynamicTimeFilterId} onChange={this.handleChange} size="small" fullWidth>
                                    {props.dynamicTimeFilters.map(dynamicTimeFilter =>
                                        <MenuItem key={dynamicTimeFilter.id} value={dynamicTimeFilter.id}>{dynamicTimeFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </Grid>
                            <Grid item sm={props.size === "sm" ? 6 : 4}>
                                <DatePicker
                                    value={state.startDateStr}
                                    disabled={state.startEndDateDisabled}
                                    onChange={this.handleStartDateChange}
                                />
                            </Grid>
                            <Grid item sm={props.size === "sm" ? 6 : 4}>
                                <DatePicker
                                    value={state.endDateStr}
                                    disabled={state.startEndDateDisabled}
                                    onChange={this.handleEndDateChange}
                                />
                            </Grid>
                        </GridRow>
                    </FormField>
                    <GridRow>
                        <Grid item sm={6}>
                            <FormField title={Translations.State}>
                                <Select name="selectedStateFilterId" title={Translations.State} value={state.selectedStateFilterId} disabled={!!props.stateIsReadOnly} onChange={this.handleChange} size="small" fullWidth>
                                    {props.stateFilters.map(stateFilter =>
                                        <MenuItem key={stateFilter.id} value={stateFilter.id}>{stateFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </FormField>
                        </Grid>
                        <Grid item sm={6}>
                            <FormField title={Translations.Severity} fullWidth>
                                <Select name="selectedSeverityFilterId" title={Translations.Severity} value={state.selectedSeverityFilterId} onChange={this.handleChange} size="small" fullWidth>
                                    {props.severityFilters.map(severityFilter =>
                                        <MenuItem key={severityFilter.id} value={severityFilter.id}>{severityFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={6}>
                            <FormField title={Translations.Resolution}>
                                <Select name="selectedResolutionFilterId" title={Translations.Resolution} value={state.selectedResolutionFilterId} onChange={this.handleChange} size="small" fullWidth>
                                    {props.resolutionFilters.map(resolutionFilter =>
                                        <MenuItem key={resolutionFilter.id} value={resolutionFilter.id}>{resolutionFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </FormField>
                        </Grid>
                        <Grid item sm={6}>
                            <FormField title={Translations.Source}>
                                <Select name="selectedSourceFilterId" title={Translations.Source} value={state.selectedSourceFilterId} onChange={this.handleChange} size="small" fullWidth>
                                    {props.sourceFilters.map(sourceFilter =>
                                        <MenuItem key={sourceFilter.id} value={sourceFilter.id}>{sourceFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={6}>
                            <FormField title={Translations.Category}>
                                <CheckboxDropdown
                                    required={true}
                                    selectedIds={state.selectedCategoryIds}
                                    toggleAll={true}
                                    toggleAllId={Base.emptyGuid}
                                    values={props.categories}
                                    onChange={this.handleChangeCategoryIds}
                                />
                            </FormField>
                        </Grid>
                        <Grid item sm={6}>
                            <FormField title={Translations.Unit}>
                                <TreeCheckboxDropdown
                                    required={true}
                                    selectedIds={state.selectedUnitIds}
                                    values={props.units}
                                    onChange={this.handleChangeUnitIds}
                                />
                            </FormField>
                        </Grid>
                    </GridRow>
                    <GridRow>
                        <Grid item sm={6}>
                            <FormField title={Translations.EventHandler}>
                                <CheckboxDropdown
                                    required={true}
                                    selectedIds={state.selectedHandlerUserCodes}
                                    toggleAll={true}
                                    values={props.handlers}
                                    onChange={this.handleChangeHandlerUserCodes}
                                />
                            </FormField>
                        </Grid>
                        <Grid item sm={6}>
                            <FormField title={Translations.Anonymity}>
                                <Select name="selectedAnonymityFilterId" title={Translations.Anonymity} value={state.selectedAnonymityFilterId} onChange={this.handleChange} size="small" fullWidth>
                                    {props.anonymityFilters.map(anonymityFilter =>
                                        <MenuItem key={anonymityFilter.id} value={anonymityFilter.id}>{anonymityFilter.title}</MenuItem>
                                    )}
                                </Select>
                            </FormField>
                        </Grid>
                    </GridRow>
                </Box>
                <FilterButtons
                    onCancel={this.handleCancel}
                    onClear={this.handleClear}
                    onSave={this.handleSave}
                />
            </Box>
        );
    }
}